<template>
  <div class="container-download-png">
    <button
      :disabled="disabledDownload"
      class="btn-file"
      @click="$emit('authorize-download', { size: pngDefaultSize, type: 'png' })"
    >
      <span v-if="!loading.png">{{ $t('preview.download.main.png') }}</span>
      <b-spinner v-else small variant="light" class="ml-2"></b-spinner>
    </button>

    <button :disabled="disabledDownload" class="btn-size" @click="$emit('toggle-more-sizes')">
      <span>{{ pngDefaultSize }}{{ $t('preview.download.main.px') }}</span>
      <Icon
        icon="bootstrap-chevron-down"
        :class="{ invert: showMoreSizes }"
        class="ml-1"
        :width="14"
        :height="14"
      />
    </button>

    <div
      v-show="showMoreSizes"
      class="container-sizes-options b-radius"
      :class="{ disabled: disabledDownload }"
    >
      <div class="container-sizes">
        <button
          v-for="(resolution, idx) in pngResolutions"
          :key="idx"
          :disabled="disabledDownload"
          @click="
            $emit('authorize-download', {
              size: resolution,
              type: `png${resolution}`
            })
          "
        >
          <span v-if="!loading[`png${resolution}`]"
            >{{ resolution }}{{ $t('preview.download.main.px') }}</span
          >
          <b-spinner v-else small variant="light" class="ml-2 p-0"></b-spinner>
        </button>
        <div class="custom-size-container d-flex align-items-center">
          <span>{{ $t('preview.download.main.customSize') }}</span>
          <input id="customSize" v-model="customSize" type="number" placeholder="Ex: 450" />
          <span>{{ $t('preview.download.main.px') }}</span>
        </div>
      </div>

      <button
        :disabled="disabledDownload"
        class="btn-size"
        @click="$emit('authorize-download', { size: customSize, type: 'pngCustom' })"
      >
        <Icon v-if="!loading.pngCustom" icon="tick" color="white" :width="30" :height="30" />
        <b-spinner v-else small variant="light" class="ml-2"></b-spinner>
      </button>
    </div>
  </div>
</template>

<script>
import Icon from 'UI/Icon';

export default {
  components: {
    Icon
  },
  props: {
    disabledDownload: {
      type: Boolean,
      required: true
    },
    showMoreSizes: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      pngDefaultSize: 1920,
      pngResolutions: [800, 1920, 2500],
      customSize: null
    };
  }
};
</script>

<style lang="scss" scoped>
button {
  background-color: #3cd699;
  border: none;
  outline: none;
  color: #fff;
}
button:disabled {
  background-color: #d2d2d2 !important;
  border-color: #d2d2d2 !important;
  cursor: not-allowed !important;
}
button:disabled:hover {
  filter: none !important;
}
.btn-file {
  border-top-left-radius: 23px;
  border-bottom-left-radius: 23px;
  font-size: 18px;
  padding: 12px 53px;
  margin-left: 15px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  @include md {
    margin-left: 0;
    margin-bottom: 7px;
    flex: 1;
    max-height: 45px;
  }
}
.b-radius {
  border-radius: 23px;
}
.btn-size {
  width: 100px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  background-color: #34bf88;
  border-top-right-radius: 23px;
  border-bottom-right-radius: 23px;
  font-size: 14px;
  padding: 8px 12px;
  flex: none;
  @include md {
    height: 45px;
  }
}
.container-download-png {
  position: relative;
  display: flex;
  z-index: 2;
}
.container-sizes-options {
  position: absolute;
  top: 55px;
  right: 0;
  display: flex;
  height: 45px;
  background-color: #3cd699;
  z-index: 1;
  border-radius: 23px;
  overflow: hidden;
  width: max-content;
  @include lg {
    flex-direction: column;
    height: auto;
    top: 52px;
    width: 100%;
    overflow: hidden;
  }
  &.disabled {
    background-color: #d2d2d2;
  }
  .btn-size {
    border-radius: 0;
    @include lg {
      width: 100%;
    }
  }
}
.container-sizes {
  display: flex;
  align-items: center;
  color: white;
  flex: none;
  font-size: 14px;
  @include lg {
    flex-direction: column;
  }
  span,
  label,
  p {
    padding: 0 15px;
  }
  button {
    padding: 0 15px;
    height: 100%;
    border-right: 1px solid #6f6f6f47;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    @include lg {
      width: 100%;
      border-bottom: 1px solid #34bf88;
      height: 45px;
    }
  }
  .custom-size-container {
    background-color: #3cd699;
    @include lg {
      height: 45px;
    }
  }
}

input[type='text'] {
  border-radius: 4px;
  width: 60px;
  padding: 5px;
}
input {
  border: none;
  outline: none;
  height: 30px;
  width: 60px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
